export default "__VITE_ASSET__BmDCu98n__"